import React, { Component } from "react";
import { objectToArray } from "../../util/commonFunctions";
import { connect } from "react-redux";
import { updateFormElements, checkFormValid } from "../../util/FormHelper";
import NewsLetterForm from "../forms/NewsLetter";
import NewsLetterConfig from "../formsConfig/NewsLetterConfig";
import { axiosUserManagement } from "../../axios";
import { setUser } from "../../actions";
import { IsEmpty } from "../../util/commonFunctions";
import { handleActionError } from "../../util/error";

class Newsletter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...{ NewsLetterConfig },
      btnDisabled: true,
      message: null,
      success: false
    };
  }

  onChangeHandler = (event, formName) => {
    const updatedFrom = updateFormElements(
      event,
      event.target.getAttribute("type"),
      this.state[formName]
    );
    this.setState({
      [formName]: updatedFrom
    });
  };

  onBlurHandler = (event, formName) => {
    this.setState({
      [formName]: updateFormElements(event, "validation", this.state[formName]),
      btnDisabled: !checkFormValid(this.state[formName]).formValid
    });
  };

  subscribeNewsletterHandler = formName => {
    event.preventDefault();
    let returnFormConfig = checkFormValid(this.state[formName]);

    if (returnFormConfig.formValid) {
      const formData = {};
      let config = {
        headers: {
          "cache-control": "no-cache",
          "content-type": "application/json",
          token: this.props.token
        }
      };
      this.setState({
        [formName]: returnFormConfig.form,
        loader: true
      });

      for (let formElementIdentifier in this.state[formName]) {
        if (!this.state[formName][formElementIdentifier].json) {
          formData[formElementIdentifier] = this.state[formName][
            formElementIdentifier
          ].value;
        }
      }

      axiosUserManagement
        .post("/subscriber/newsletter", formData, { ...config })
        .then(res => {
            this.setState({
              loader: false,
              success: true,
              successMessage: res.data.message
            });
          this.getUserInfo(this.props.token);
        })
        .catch(err => {
          handleActionError("An error occurred while attempting to subscribe to the newsletter:", err);
          if(this.props.token){
            this.setState({
              loader: false,
              errorMessage: err.response.data.message
            });
          } else {
            this.setState({
              loader: false,
              errorMessage: 'Please sign up to subscribe for the newsletter'
            });
          }
        });
    } else {
      this.setState({
        [formName]: returnFormConfig.form
      });
    }
  };

  getUserInfo = token => {
    if (!IsEmpty(token)) {
      this.props.setUser(token);
    }
  };

  render = () => {
    return (
      <div className="lightTheme newsLetter staticSection">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-2 noDisplayMobile">
              <img src="assets/svg/envelope.svg" alt="envelope" />
            </div>
            <div className="col-12 col-md-5">
              <NewsLetterForm
                form={objectToArray(this.state.NewsLetterConfig)}
                formName="NewsLetterConfig"
                btnDisabled={this.state.btnDisabled}
                onChangeHandler={this.onChangeHandler}
                onBlurHandler={this.onBlurHandler}
                sucessHandler={this.subscribeNewsletterHandler}
                errorMessage={this.state.errorMessage}
                successMessage={this.state.successMessage}
                sucessState={this.state.success}
              />
            </div>

            <div className="col-md-5 noDisplayMobile">
              <ul>
                <li>
                  <img src="/assets/svg/shape.svg" alt="tick" />
                  Stock of the day
                </li>
                <li>
                  <img src="/assets/svg/shape.svg" alt="tick" />
                  Our top interviews
                </li>
                <li>
                  <img src="/assets/svg/shape.svg" alt="tick" />
                  Opinions on the market and macro landscape
                </li>
                <li>
                  <img src="/assets/svg/shape.svg" alt="tick" />
                  The COB podcast
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setUser: token => dispatch(setUser(token))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Newsletter);
